var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isButton ? 'svg-container btn-icon' : 'svg-container',staticStyle:{"margin-top":"0"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.9,12,1,6.1,2.4,4.7,6.9,9.1,15,1l1.4,1.4Z","transform":"translate(-1 1)","fill":_vm.iconColor}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }